import React, { useState } from 'react';
import { Button } from './ui/button';
import { MessageSquare, Download, Headset, X, CheckCircle, Clock, Shield, Zap } from 'lucide-react';

const RemoteSupport = () => {
  const [showModal, setShowModal] = useState(false);

  const remoteTools = [
    {
      name: 'AnyDesk',
      logo: './logo-anydesk.png',
      link: 'https://anydesk.com/pt/downloads/thank-you?dv=win_exe',
      description: 'Rápido e seguro',
      color: 'from-red-500 to-red-600'
    },
    {
      name: 'UltraViewer',
      logo: './logo-ultraviewer.png',
      link: 'https://www.ultraviewer.net/pt/UltraViewer_setup_6.6_pt.exe',
      description: 'Simples de usar',
      color: 'from-blue-500 to-blue-600'
    },
    {
      name: 'TightVNC',
      logo: './logo-tightvnc.png',
      link: 'https://www.tightvnc.com/download/2.8.85/tightvnc-2.8.85-gpl-setup-64bit.msi',
      description: 'Open Source',
      color: 'from-green-500 to-green-600'
    }
  ];

  return (
    <>
      <section id="suporte-remoto" className="py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden" style={{ scrollMarginTop: '100px' }}>
        {/* Background decorativo */}
        <div className="absolute inset-0 opacity-10 pointer-events-none overflow-hidden">
          <div className="absolute top-20 right-0 w-64 sm:w-80 md:w-96 h-96 bg-cyan-500 rounded-full filter blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 left-0 w-56 sm:w-64 md:w-80 h-80 bg-blue-500 rounded-full filter blur-3xl animate-pulse delay-1000"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-5xl mx-auto">
            {/* Header */}
            <div className="text-center mb-12">
              <div className="inline-flex items-center justify-center gap-2 mb-4 px-4 py-2 bg-cyan-500/10 border border-cyan-500/30 rounded-full">
                <Headset className="w-5 h-5 text-cyan-400" />
                <span className="text-cyan-400 font-semibold text-sm uppercase tracking-wider">Help Desk TI Especializado</span>
              </div>
              <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 bg-gradient-to-r from-white via-cyan-200 to-blue-200 bg-clip-text text-transparent">
                Suporte Remoto de TI
              </h2>
              <p className="text-xl md:text-2xl text-blue-200 mb-4 font-light">
                Help desk TI para resolver problemas de onde você estiver!
              </p>
              <p className="text-lg text-slate-300 max-w-3xl mx-auto">
                Suporte remoto de TI e atendimento presencial com técnicos especializados. Ideal para empresas que buscam suporte técnico empresarial por contrato ou chamados eventuais. <span className="text-cyan-400 font-semibold">Serviços de TI para empresas: rápido, seguro e eficiente.</span>
              </p>
            </div>

            {/* Benefícios */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-12">
              <div className="bg-slate-800/50 backdrop-blur-sm border border-cyan-500/20 rounded-lg p-4 text-center hover:border-cyan-500/50 transition-all duration-300 hover:scale-105">
                <Clock className="w-8 h-8 text-cyan-400 mx-auto mb-2" />
                <h3 className="text-white font-semibold mb-1">Suporte Ágil</h3>
                <p className="text-slate-400 text-sm">Help desk TI rápido</p>
              </div>
              <div className="bg-slate-800/50 backdrop-blur-sm border border-cyan-500/20 rounded-lg p-4 text-center hover:border-cyan-500/50 transition-all duration-300 hover:scale-105">
                <Shield className="w-8 h-8 text-cyan-400 mx-auto mb-2" />
                <h3 className="text-white font-semibold mb-1">100% Seguro</h3>
                <p className="text-slate-400 text-sm">Conexão criptografada</p>
              </div>
              <div className="bg-slate-800/50 backdrop-blur-sm border border-cyan-500/20 rounded-lg p-4 text-center hover:border-cyan-500/50 transition-all duration-300 hover:scale-105">
                <CheckCircle className="w-8 h-8 text-cyan-400 mx-auto mb-2" />
                <h3 className="text-white font-semibold mb-1">TI Especializada</h3>
                <p className="text-slate-400 text-sm">Profissionais certificados</p>
              </div>
              <div className="bg-slate-800/50 backdrop-blur-sm border border-cyan-500/20 rounded-lg p-4 text-center hover:border-cyan-500/50 transition-all duration-300 hover:scale-105">
                <Zap className="w-8 h-8 text-cyan-400 mx-auto mb-2" />
                <h3 className="text-white font-semibold mb-1">Solução Imediata</h3>
                <p className="text-slate-400 text-sm">Suporte remoto de TI</p>
              </div>
            </div>

            {/* Call to Actions */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Button
                size="lg"
                className="bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600 text-white font-bold px-10 py-6 text-lg shadow-xl shadow-green-600/40 hover:shadow-green-600/60 transition-all duration-300 hover:scale-110 rounded-xl"
                onClick={() => window.open('https://wa.me/5516991378312?text=Olá! Preciso de suporte técnico remoto urgente!', '_blank')}
              >
                <MessageSquare className="mr-3" size={24} />
                Fale no WhatsApp Agora
              </Button>
              <Button
                size="lg"
                className="bg-gradient-to-r from-cyan-600 to-blue-600 hover:from-cyan-700 hover:to-blue-700 text-white font-bold px-10 py-6 text-lg shadow-xl shadow-cyan-500/40 hover:shadow-cyan-500/60 transition-all duration-300 hover:scale-110 rounded-xl"
                onClick={() => setShowModal(true)}
              >
                <Download className="mr-3" size={24} />
                Baixar Software Remoto
              </Button>
            </div>

            {/* Texto adicional */}
            <div className="text-center mt-8">
              <p className="text-slate-400 text-sm">
                💡 <span className="text-cyan-400">Dica:</span> Baixe o software de acesso remoto antes de entrar em contato para agilizar o atendimento
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Modal de Downloads */}
      {showModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-fadeIn">
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 border-2 border-cyan-500/50 rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto shadow-2xl shadow-cyan-500/20 animate-scaleIn">
            {/* Header do Modal */}
            <div className="sticky top-0 bg-gradient-to-r from-slate-900 to-slate-800 border-b border-cyan-500/30 p-6 flex items-center justify-between z-10">
              <div>
                <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">Escolha o Software de Acesso Remoto</h3>
                <p className="text-slate-400">Selecione uma das opções abaixo para fazer o download</p>
              </div>
              <button
                onClick={() => setShowModal(false)}
                className="text-slate-400 hover:text-white transition-colors p-2 hover:bg-slate-700 rounded-lg"
              >
                <X size={28} />
              </button>
            </div>

            {/* Conteúdo do Modal */}
            <div className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {remoteTools.map((tool, index) => (
                  <div
                    key={index}
                    className="group bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl hover:shadow-cyan-500/30 transition-all duration-500 hover:-translate-y-2 border-2 border-transparent hover:border-cyan-500/50 cursor-pointer"
                    onClick={() => window.open(tool.link, '_blank')}
                  >
                    {/* Badge de download */}
                    <div className="absolute top-3 right-3 bg-gradient-to-r from-cyan-500 to-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center gap-1">
                      <Download className="w-3 h-3" />
                      Download
                    </div>

                    {/* Logo */}
                    <div className="flex items-center justify-center h-32 mb-4 bg-slate-50 rounded-lg p-4 group-hover:bg-slate-100 transition-colors duration-300">
                      <img
                        src={tool.logo}
                        alt={tool.name}
                        className="max-w-full max-h-full object-contain transform group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>

                    {/* Nome */}
                    <h4 className="text-xl font-bold text-slate-800 text-center mb-2 group-hover:text-cyan-600 transition-colors duration-300">
                      {tool.name}
                    </h4>

                    {/* Descrição */}
                    <p className="text-slate-500 text-center text-sm mb-4">
                      {tool.description}
                    </p>

                    {/* Botão de Download */}
                    <button
                      className={`w-full bg-gradient-to-r ${tool.color} text-white font-bold py-3 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2 group-hover:scale-105`}
                    >
                      <Download size={18} />
                      Baixar Agora
                    </button>

                    {/* Indicador de sistema */}
                    <p className="text-xs text-slate-400 text-center mt-3">
                      💻 Windows
                    </p>
                  </div>
                ))}
              </div>

              {/* Informações adicionais */}
              <div className="mt-8 bg-slate-800/50 border border-cyan-500/20 rounded-xl p-6">
                <div className="flex items-start gap-3 mb-4">
                  <Shield className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
                  <div>
                    <h5 className="text-white font-semibold mb-2">Instruções de Uso:</h5>
                    <ol className="text-slate-300 text-sm space-y-2 list-decimal list-inside">
                      <li>Baixe e instale um dos programas acima</li>
                      <li>Execute o software e anote o ID/Código gerado</li>
                      <li>Entre em contato pelo WhatsApp e informe o código</li>
                      <li>Nossa equipe irá acessar remotamente e resolver seu problema</li>
                    </ol>
                  </div>
                </div>
                <div className="flex items-center justify-center gap-2 text-cyan-400 text-sm font-semibold pt-4 border-t border-slate-700">
                  <CheckCircle size={18} />
                  <span>Todas as conexões são seguras e criptografadas</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
        .animate-scaleIn {
          animation: scaleIn 0.3s ease-out;
        }
      `}</style>
    </>
  );
};

export default RemoteSupport;